import { render, staticRenderFns } from "./AvatarEvent.vue?vue&type=template&id=10a27b5b&scoped=true&"
import script from "./AvatarEvent.vue?vue&type=script&setup=true&lang=js&"
export * from "./AvatarEvent.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a27b5b",
  null
  
)

export default component.exports